import { createClient } from '@neondatabase/neon-js';
import { BetterAuthReactAdapter } from '@neondatabase/neon-js/auth/react/adapters';
import { env, isBackendConfigured } from './env';

/**
 * One client for Managed Better Auth and the Neon Data API. Every query runs as the signed-in
 * user's JWT and is constrained by row level security in Postgres; nothing here is trusted for
 * authorization.
 */
export const db = createClient({
  auth: {
    // Auth goes through the Worker on this origin (/api/auth → Neon Auth) so the session cookie is
    // first-party; browsers that block third-party cookies would otherwise drop it after sign-in.
    url: isBackendConfigured ? `${env.apiBase || window.location.origin}/api/auth` : 'https://auth.invalid/auth',
    adapter: BetterAuthReactAdapter(),
  },
  dataApi: {
    url: isBackendConfigured ? env.dataApiUrl : 'https://data-api.invalid/rest/v1',
  },
});

/** Better Auth client (sign-in, sign-up, sessions, email OTP). */
export const authClient = db.auth;

/** The current user's JWT for calling the Worker API, or null when signed out. */
export async function getAccessToken(): Promise<string | null> {
  const { data } = await authClient.getSession();
  return data?.session?.token ?? null;
}

/** Throws the Data API error (with a readable message) or returns data. */
export function unwrap<T>(result: { data: T; error: { message: string } | null }): T {
  if (result.error) throw new Error(result.error.message);
  return result.data;
}
